// @flow
import Spinner from 'esm-web-pro/components/forms/Spinner';
import * as React from 'react';
import { connect } from 'react-redux';
import type { Form } from 'esm-web-pro/redux/workflow/form';
import { getModalForms } from 'esm-web-pro/redux/workflow/form';
import { WorkflowContext } from 'esm-web-pro/components';
import connectWorkflow from 'esm-web-pro/components/workflows/connectWorkflow';
import WorkflowModalForm from 'esm-web-pro/containers/workflows/WorkflowModalForm';

const mapStateToProps = (state) => ({
    modalForms: getModalForms(state),
});

type Props = {
    modalForms: {
        code: string,
        form: Array<Form>
    },
    resumeFlow: Function,
    setLoading: Function,
}

type State = {
    loading: boolean,
}

@connectWorkflow
@connect(mapStateToProps)
class WorkflowForms extends React.Component<Props, State> {
    static contextType = WorkflowContext;

    static defaultProps = {
        modalForms: [],
        resumeFlow: () => undefined,
    };

    state = {
        loading: false,
    };

    setLoading = (loading) => {
        this.setState({ loading });
    };

    render() {
        const { modalForms, resumeFlow } = this.props;
        const { workflowManager } = this.context;
        const { loading } = this.state;
        return (
            <>
                <Spinner loading={loading} />
                {modalForms.map((form) => (
                    <WorkflowModalForm
                        {...form}
                        key={`${form.requestKey}${form.executionId}`}
                        resumeFlow={resumeFlow}
                        workflowManager={workflowManager}
                        setLoading={this.setLoading}
                    />
                ))}
            </>
        );
    }
}

export default WorkflowForms;
